const colors = {
  bg: '#0a0a0a',
  surface: '#121212',
  surfaceElevated: '#1a1a1a',
  border: '#262626',
  text: '#ededed',
  textMuted: '#a1a1aa',
  primary: '#6366f1',
  primaryHover: '#4f46e5',
  success: '#22c55e',
  danger: '#ef4444',
}

const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
}

const radii = {
  sm: '6px',
  md: '10px',
  lg: '16px',
  full: '9999px',
}

const typography = {
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontSize: {
    base: '16px',
    sm: '14px',
    lg: '18px',
    xl: '20px',
    xxl: '24px',
  },
  lineHeight: {
    tight: '1.2',
    normal: '1.5',
    relaxed: '1.7',
  },
}

const breakpoints = {
  sm: '480px',
  md: '768px',
  lg: '1024px',
}

const theme = {
  colors,
  spacing,
  radii,
  typography,
  breakpoints,
}

export { theme }
